import {RotatingLines} from "react-loader-spinner";
import {ButtonHTMLAttributes} from "react";

export interface BaseButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    name: string;
    loading: boolean;
}

export default function BaseButton({name, loading, ...props}: BaseButtonProps) {
    return (
        <>
            <button className="button w-button" {...props}>
                {loading ? <p style={{margin: "auto", marginTop: "5px"}}>
                    <RotatingLines
                        visible={true} width="25" strokeWidth="5" animationDuration="0.75"
                        ariaLabel="rotating-lines-loading" strokeColor={'#fff'}
                    />
                </p> : name
                }
                {/*{name ? name : loading && (*/}
                {/*    <p style={{margin: "auto", marginTop: "15px"}}>*/}
                {/*        <TailSpin*/}
                {/*            visible={true}*/}
                {/*            height={30}*/}
                {/*            width={30}*/}
                {/*            color="#ec9c3f"*/}
                {/*            ariaLabel="tail-spin-loading"*/}
                {/*            strokeWidth={5}*/}
                {/*            wrapperStyle={{}}*/}
                {/*            wrapperClass=""*/}
                {/*        />*/}
                {/*    </p>*/}
                {/*)}*/}
            </button>
        </>
    )
}